import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import Text from 'UIKit/Text'
import { BonusStatusEnums } from 'config/types/bonus'
import { BoosterWagerBonus } from 'config/types/bonus/userBonus'
import { Trans } from 'react-i18next'
import { BonusContentFieldTitle, BonusContentGridSystem } from '../styled'

const BonusContentBoostedAmount: React.FC<{ bonus: BoosterWagerBonus } & BoxProps> = ({ bonus, ...props }) => {
  return [BonusStatusEnums.Used, BonusStatusEnums.Active].includes(bonus.status) ? (
    <Box {...props}>
      <BonusContentGridSystem>
        <BonusContentFieldTitle>
          <Trans>Boosted</Trans>
        </BonusContentFieldTitle>
        <Text fontWeight="600" fontSize="12px">
          {`$${bonus.boostedAmount}`}
        </Text>
      </BonusContentGridSystem>
      <BonusContentGridSystem mt="8px">
        <BonusContentFieldTitle>
          <Trans>Max</Trans>
        </BonusContentFieldTitle>
        <Text fontWeight="600" fontSize="12px">
          {`$${bonus.maxBooster}`}
        </Text>
      </BonusContentGridSystem>
    </Box>
  ) : (
    <BonusContentGridSystem mt="8px">
      <BonusContentFieldTitle>
        <Trans>Max Boostable</Trans>
      </BonusContentFieldTitle>
      <Text fontWeight="600" fontSize="12px">
        {`$${bonus.maxBooster}`}
      </Text>
    </BonusContentGridSystem>
  )
}

export default BonusContentBoostedAmount
